import * as React from 'react';
import { listenerCount } from 'cluster';
import Icon from './icon';
import * as moment from 'moment';

export interface CalendarProps {
    value?: Date;
    style?: React.CSSProperties;
    className?: string;
    onChange?: (date: Date) => void;
}

export interface CalendarState {
    currentDate?: Date;
    calendarDate: Date;
    mode: 'month' | 'year' | 'century';
}


function getDate(date: Date)
{
    const result = new Date(date);

    result.setSeconds(0);
    result.setMilliseconds(0);
    result.setMinutes(0);
    result.setHours(0);

    return result;
}


function getYearName(n: number){

    if(n == 0)
        return 'JAN';
    if(n == 1)
        return "FEB";
    if(n == 2)
        return "MAR";
    if(n == 3)
        return "APR";
    if(n == 4)
        return "MAY";
    if(n == 5)
        return "JUN";
    if(n == 6)
        return "JUL";
    if(n == 7)
        return "AUG";
    if(n == 8)
        return "SEP";
    if(n == 9)
        return "OCT";
    if(n == 10)
        return "NOV";
    if(n == 11)
        return "DEC";

  }

export default class Calendar extends React.Component<CalendarProps, CalendarState> {
  
    constructor(props: CalendarProps) {
    super(props);

    this.state = {
        calendarDate: new Date(Date.now()),
        mode: 'month'
    }
  }

  public componentDidMount(){

    var date = this.props.value || new Date(Date.now())
     this.setState({calendarDate: date, currentDate: this.props.value})

  }


  public componentWillReceiveProps(nextProps: CalendarProps){
      if(nextProps.value != this.props.value){
          this.setState({currentDate: nextProps.value});
      }
  }



  getMonth = () => {

      const {calendarDate} = this.state;
      return `${getYearName(calendarDate.getMonth())} ${calendarDate.getFullYear()}`;
  }

  getYear = () => {

    const {calendarDate} = this.state;
    return calendarDate.getFullYear();
  }

  addOneMonth = () => {

    let date = moment(this.state.calendarDate);
    const unit = this.getUnit();

    date = date.add(unit.type as any, unit.step);

    this.setState({calendarDate: date.toDate()});
  }

  getUnit = () => {
      switch(this.state.mode){
        case 'month':
            return { step: 1, type: 'month' };
        
        case 'year':
            return { step: 1, type: 'year' };
        
        case 'century':
            return { step: 12, type: 'year' };
      }
  }

  minusOneMonth = () => {
        let date = moment(this.state.calendarDate);
        const unit = this.getUnit();

        date = date.add(unit.type as any, -1*unit.step);

        this.setState({calendarDate: date.toDate()});
  }

  public drawMonthMode = () => {
      return (
          <React.Fragment>
                
            </React.Fragment>
      );
  }

  getTitle = () => {

    if(this.state.mode == 'month')
        return this.getMonth();
    if(this.state.mode == 'year')
        return this.getYear();
    if(this.state.mode == 'century')
        return `${this.getYear() - 12}-${this.getYear()}`
  }

  scaleUp = () => {
      if(this.state.mode == 'month')
        this.setState({mode: 'year'});
      else if(this.state.mode == 'year')
        this.setState({mode: 'century'});
  }

  scaleIn = () => {

    if(this.state.mode == 'century')
        this.setState({mode: 'year'});
    else if(this.state.mode == 'year')
        this.setState({mode: 'month'});
  }

  renderContent = () => {
      switch(this.state.mode){
          case 'month':
            return <DaysView calendarDate={this.state.calendarDate} currentDate={this.state.currentDate} onChange={this.props.onChange}/>
          case 'year':
            return <YearView calendarDate={this.state.calendarDate} year={this.state.calendarDate.getFullYear()} currentDate={this.state.currentDate} onChange={this.changeMonth}/>;
          case 'century':
            return <CenturyView calendarDate={this.state.calendarDate} finalYear={this.getYear()} currentDate={this.state.currentDate} onChange={this.changeYear} />;
      }
  }

  changeYear = (year: number) => {

    this.setState({calendarDate: moment(this.state.calendarDate).set('year', year).toDate()}, this.scaleIn)
  }

  changeMonth = (month: number) => {
      this.setState({calendarDate: moment(this.state.calendarDate).set('month', month).toDate()}, this.scaleIn)
  }

  public render() {


    return (
      <div className={`calendar ${this.props.className || ''}`} style={this.props.style}>
         <div className="calendar-header" >
                <Icon type="caret-left" className='prev-calendar' onClick={this.minusOneMonth} />
                <h4 className='month-value' onClick={this.scaleUp}>{this.getTitle()}</h4>
                <Icon type="caret-right" className='next-calendar'  onClick={this.addOneMonth}/>
            </div>
            <hr className='calendar-divider' />
            {this.renderContent()}
            </div>
    );
  }
}


export interface DaysViewProps {
    calendarDate: Date;
    currentDate?: Date;
    onChange?: (date: Date) => void;
}

export interface DaysViewState {
}

export class DaysView extends React.Component<DaysViewProps, DaysViewState> {
  constructor(props: DaysViewProps) {
    super(props);

    this.state = {
    }
  }


  drawCalendar = () => 
  {

      if(this.props.currentDate == null)
        return null;

      const  calendarDate = this.props.calendarDate;
      const currentDate = this.props.currentDate;

      const rows: React.ReactNode[] = [];

      let begin = new Date(calendarDate);
      begin = getDate(begin);

      begin.setDate(1);


      for(let delta = begin.getDay(); delta > 0; delta--)
        begin.setDate(begin.getDate()-1);


      for(let i = 0; i < 6; i++){
          const row: React.ReactNode[] = [];
          for(let j = 0; j < 7; j++){

              const isInMonth = calendarDate.getMonth() == begin.getMonth();
              const now = getDate(new Date(Date.now()));

              const isCurrent = now.getTime() == begin.getTime();
              const isValue = currentDate && begin.getTime() == getDate(currentDate).getTime()

              const reference = getDate(new Date(begin));
              row.push(<span onClick={() => {if(this.props.onChange)this.props.onChange(reference)}} key={begin.getTime()} className={`calendar-week-day ${isInMonth? 'calendar-in-month': ''} ${isCurrent? 'calendar-now':''} ${isValue?'calendar-value': ''}`}>{begin.getDate()}</span>)
              begin.setDate(begin.getDate() + 1);
          }
          rows.push(<div key={begin.getTime()} className="calendar-week-days">{row}</div>);
      }

      return rows;
  }



  public render() {

    if(this.props.currentDate == null)
        return null;

    return (
      <React.Fragment>
        <div className='calendar-week-names'>
            <h4 className='calendar-week-name'>Su</h4>
            <h4 className='calendar-week-name'>M</h4>
            <h4 className='calendar-week-name'>Tu</h4>
            <h4 className='calendar-week-name'>W</h4>
            <h4 className='calendar-week-name'>Th</h4>
            <h4 className='calendar-week-name'>F</h4>
            <h4 className='calendar-week-name'>Sa</h4>
        </div>
        {this.drawCalendar()}
      </React.Fragment>
    );
  }
}

export interface YearViewProps {
    calendarDate: Date;
    currentDate?: Date;
    year: number;
    onChange?: (month: number) => void;
}

export interface YearViewState {
}

export class YearView extends React.Component<YearViewProps, YearViewState> {
  constructor(props: YearViewProps) {
    super(props);

    this.state = {
    }
  }

  drawCalendar = () => 
  {
    

      const currentDate = this.props.currentDate;

    if(currentDate == null)
        return null;

      const rows: React.ReactNode[] = [];

      let begin = new Date(currentDate);
      begin = getDate(begin);

      begin.setDate(1);


      for(let delta = begin.getDay(); delta > 0; delta--)
        begin.setDate(begin.getDate()-1);


      for(let i = 0; i < 3; i++){
          const row: React.ReactNode[] = [];
          for(let j = 0; j < 4; j++){

              const monthNumber = i*4 + j;

              const isCurrent = monthNumber == this.props.calendarDate.getMonth() && this.props.year == this.props.calendarDate.getFullYear();

              row.push(<span key={j} onClick={() => 
                { 
                    if(this.props.onChange)
                        this.props.onChange(i*4 + j)
                }} className={`calendar-week-day calendar-in-month month `}>{getYearName(i*4 + j)}</span>)
              
          }
          rows.push(<div key={i} className="calendar-week-days">{row}</div>);
      }

      return rows;
  }

  public render() {

    if(!this.props.currentDate)
        return null;

    return this.drawCalendar();
  }
}


export interface CenturyViewProps {

    finalYear: number;
    calendarDate: Date;
    currentDate?: Date;
    onChange?: (year: number) => void;
}

export interface CenturyViewState {
}

export class CenturyView extends React.Component<CenturyViewProps, CenturyViewState> {
  constructor(props: CenturyViewProps) {
    super(props);

    this.state = {
    }
  }
  drawCalendar = () => 
  {
    

      const currentDate = this.props.currentDate;

    if(currentDate == null)
        return null;

      const rows: React.ReactNode[] = [];

      let begin = new Date(currentDate);
      begin = getDate(begin);

      begin.setDate(1);


      for(let delta = begin.getDay(); delta > 0; delta--)
        begin.setDate(begin.getDate()-1);


      for(let i = 0; i < 3; i++){
          const row: React.ReactNode[] = [];
          for(let j = 0; j < 4; j++){

              const year = this.props.finalYear - i*4 - j;

              row.push(<span key={j} onClick={() => 
                { 
                    if(this.props.onChange)
                        this.props.onChange(year)
                }} className={`calendar-week-day calendar-in-month year`}>{year}</span>)
              
          }
          rows.push(<div key={i} className="calendar-week-days">{row}</div>);
      }

      return rows;
  }

  public render() {

    if(!this.props.currentDate)
        return null;

    return this.drawCalendar();
  }
}



// WEBPACK FOOTER //
// ./src/core/ui/calendar.tsx